var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResAmazonEc2ElasticIpAddress48Light(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Resource/Compute/Res_Amazon-EC2_Elastic-IP-Address_48_Light") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Resource/Compute/Res_Amazon-EC2_Elastic-IP-Address_48",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.62,24.058 L43.62,23.794 L43.742,23.926 L43.62,24.058 Z M10.926,30.852 C7.106,30.852 4,27.746 4,23.926 C4,20.107 7.106,17 10.926,17 C14.745,17 17.851,20.107 17.851,23.926 C17.851,27.746 14.745,30.852 10.926,30.852 L10.926,30.852 Z M45.839,23.246 L39.398,16.31 L37.933,17.671 L42.813,22.926 L19.792,22.926 C19.293,18.474 15.51,15 10.926,15 C6.004,15 2,19.004 2,23.926 C2,28.848 6.004,32.852 10.926,32.852 C15.51,32.852 19.293,29.378 19.792,24.926 L42.813,24.926 L37.933,30.181 L39.398,31.542 L45.839,24.607 C46.195,24.223 46.195,23.629 45.839,23.246 L45.839,23.246 Z",
    id: "Amazon-EC2-Elastic-IP-address_Resource-Icon_light-bg",
    fill: "#D45B07"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResAmazonEc2ElasticIpAddress48Light);
export default __webpack_public_path__ + "static/media/Res_Amazon-EC2_Elastic-IP-Address_48_Light.622bad4ceddd44efd0da6b896775c089.svg";
export { ForwardRef as ReactComponent };